/* eslint-disable consistent-return */
import EmojiButton from 'emoji-button';
import autosize from 'autosize';
import { log, logMethodCall } from '../utils/debug';
import { isAndroid } from '../utils/env';
import { translate } from '../utils/translate';
import { domLoaded } from '../utils/dom';
import request from '../utils/request';
import { getApiEndpoint } from '../utils/getApiEndpoint';

import CleverPushApi from '../api';

require('./chat.scss');

const MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  BUTTON: 'button'
};
const URL_SHORTENER_DOMAIN = 'clpsh.com';
const URL_REGEX = /(?:(?:https?):\/\/|www\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
export default class Chat {
  constructor(subscriptionId, config, server, _, isOpenInWidget, createGuestSubscription) {
    this.server = server;
    this.subscriptionId = subscriptionId;
    this.preview = subscriptionId === 'preview';
    this.guestsEnabled = config.chatGuestsEnabled;
    this.config = config;
    this.config = { ...config };
    this.isOpenInWidget = isOpenInWidget || false;
    this.chat = document.querySelector(`${this.isOpenInWidget ? '.cleverpush-sticky-widget' : '.cleverpush-chat-target'}`);
    this.createGuestSubscription = createGuestSubscription;
    this.apiEndpoint = getApiEndpoint();
    this.darkTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (this.config) {
      this.addStylingFromConfigToHtml();
    }
  }

  addStylingFromConfigToHtml() {
    const brandingStyle = document.createElement('style');
    brandingStyle.innerHTML = '';

    if (this.config.chatBackgroundColor) {
      brandingStyle.innerHTML += `
      .cleverpush-chat-target, .cleverpush-chat-target .cleverpush-chat-wrap .cleverpush-chat-bubble-container .cleverpush-chat-bubble-channel-arrow:after, .cleverpush-chat-target .cleverpush-chat-wrap .cleverpush-chat-bubble-container .cleverpush-chat-bubble-subscriber:after {
          background-color: ${this.config.chatBackgroundColor} !important;
        }
        `;
    }

    if (this.config.chatWidgetThemeColor) {
      brandingStyle.innerHTML += `
        .cleverpush-chat-btn {
          background-color: ${this.config.chatWidgetThemeColor} !important;
        }
        .cleverpush-chat-bubble-subscriber {
          background-color: ${this.config.chatWidgetThemeColor} !important;
        }
        .cleverpush-chat-bubble-subscriber:before {
          border-right-color: ${this.config.chatWidgetThemeColor} !important;
        }
        `;
    } else if (this.config.brandingColor) { // App SDKs
      brandingStyle.innerHTML += `
        .cleverpush-chat-btn {
          background-color: ${this.config.brandingColor} !important;
        }
        .cleverpush-chat-bubble-subscriber {
          background-color: ${this.config.brandingColor} !important;
        }
        .cleverpush-chat-bubble-subscriber:before {
          border-right-color: ${this.config.brandingColor} !important;
        }
        `;
    }

    if (this.config.displayChatWidget) {
      brandingStyle.innerHTML += `
        .cleverpush-chat-bubble-container {
          min-height: 335px;
          max-height: 335px
        }
        `;
    }

    const widgetTextColorStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
        .cleverpush-chat-btn {
          color: ${color} !important;
        }
        .cleverpush-chat-bubble-subscriber {
          color: ${color} !important;
        }
        `;
    };

    const chatButtonColorStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
      .cleverpush-chat-btn {
        background-color: ${color} !important;
      }
        `;
    };

    const widgetInputBoxColorStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
        .cleverpush-chat-input-textarea {
          background-color: ${color} !important;
        }
        `;
    };

    const inputContainerStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
        .cleverpush-chat-input-container {
          background-color: ${color} !important;
        }
        `;
    };

    const widgetInputTextColorStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
        .cleverpush-chat-input-textarea {
          color: ${color} !important;
        }
        `;
    };

    const chatBubbleColor = (styleKey, color) => {
      if (!color) {
        return;
      }
      brandingStyle.innerHTML += `
        .cleverpush-chat-bubble-container .cleverpush-chat-bubble-channel-arrow {
          ${styleKey}: ${color} !important;
        }
        .cleverpush-chat-bubble-container .cleverpush-chat-bubble-channel {
          ${styleKey}: ${color} !important;
        }`;
    };

    const receiverBubbleColorStyle = (color) => {
      if (!color) {
        return;
      }

      chatBubbleColor('background-color', color);
      brandingStyle.innerHTML += `
        .cleverpush-chat-bubble-container .cleverpush-chat-bubble-channel-arrow:before {
          border-left-color: ${color} !important;
        }

        .cleverpush-chat-bubble-container .cleverpush-chat-bubble-channel-arrow:after {
          background-color: ${this.config.chatBackgroundColor || '#FFFFFF'} !important;
        }
        `;
    };

    const chatBubbleContainerStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
        .cleverpush-chat-wrap .cleverpush-chat-bubble-container .cleverpush-chat-date  {
          color: ${color} !important;
        }
        `;
    };

    const chatSenderBubbleBackgroundColorStyle = (color) => {
      if (!color) {
        return;
      }

      brandingStyle.innerHTML += `
      .cleverpush-chat-bubble-subscriber {
        background-color: ${color} !important;
      }
      .cleverpush-chat-bubble-subscriber:before {
        border-right-color: ${color} !important;
         }

         .cleverpush-chat-bubble-container .cleverpush-chat-bubble-subscriber-arrow:after {
            background-color: ${this.config.chatBackgroundColor || '#FFFFFF'}
         }
      `;
    };

    const widgetTextColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.widgetTextColor) || this.config.chatStylingOptions?.widgetTextColor;
    const chatButtonColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.chatButtonColor) || this.config.chatStylingOptions?.chatButtonColor;
    const widgetInputBoxColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.widgetInputBoxColor) || this.config.chatStylingOptions?.widgetInputBoxColor;
    const widgetInputTextColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.widgetInputTextColor) || this.config.chatStylingOptions?.widgetInputTextColor;
    const receiverBubbleColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.receiverBubbleColor) || this.config.chatStylingOptions?.receiverBubbleColor;
    const inputContainer = (this.darkTheme && this.config.chatStylingOptions?.dark?.inputContainer) || this.config.chatStylingOptions?.inputContainer;
    const dateColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.dateColor) || this.config.chatStylingOptions?.dateColor;
    const receiverTextColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.receiverTextColor) || this.config.chatStylingOptions?.receiverTextColor;
    const chatSenderBubbleBackgroundColor = (this.darkTheme && this.config.chatStylingOptions?.dark?.chatSenderBubbleBackgroundColor) || this.config.chatStylingOptions?.chatSenderBubbleBackgroundColor;

    widgetTextColorStyle(widgetTextColor);
    chatButtonColorStyle(chatButtonColor);
    widgetInputBoxColorStyle(widgetInputBoxColor, !!this.config.brandingColor);
    widgetInputTextColorStyle(widgetInputTextColor);
    receiverBubbleColorStyle(receiverBubbleColor);
    inputContainerStyle(inputContainer);
    chatBubbleContainerStyle(dateColor);
    chatBubbleColor('color', receiverTextColor);
    chatSenderBubbleBackgroundColorStyle(chatSenderBubbleBackgroundColor);

    if (this.config.nativeAppPlatform === 'Android') {
      brandingStyle.innerHTML += `
        .cleverpush-chat-input-textarea {
          border-radius: 8px !important;
          box-shadow: 1px 2px 4px rgba(0,0,0,0.05) !important;
        }
        `;
    }

    document.head.appendChild(brandingStyle);
  }

  request(method, path, data) {
    logMethodCall('request', method, path, data);

    const options = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      }
    };
    if (method) {
      options.method = method;
    }
    if (data) {
      options.body = JSON.stringify({ sdkVersion: typeof VERSION !== 'undefined' ? VERSION : undefined, ...data });
      options.headers['Content-Type'] = 'application/json';
    }
    return request(this.endpoint + path, options);
  }

  newDateString(date) {
    const now = new Date();
    let result = '';
    if (
      date.getFullYear() === date.getFullYear()
      && date.getMonth() === now.getMonth()
      && now.getDate() - date.getDate() < 3
    ) {
      switch (now.getDate() - date.getDate()) {
        case 0:
          result = `${translate('chat.today')}`;
          break;
        case 1:
          result = `${translate('chat.yesterday')}`;
          break;
        case 2:
          result = `${translate('chat.dayBefore')}`;
          break;
        default:
          result = '';
      }
    } else if (
      date.getFullYear() === date.getFullYear()
      && date.getMonth() === now.getMonth()
      && now.getDate() - date.getDate() > 2
      && now.getDate() - date.getDate() < 7
    ) {
      switch (date.getDay()) {
        case 0:
          result = `${translate('chat.sunday')}`;
          break;
        case 1:
          result = `${translate('chat.monday')}`;
          break;
        case 2:
          result = `${translate('chat.tuesday')}`;
          break;
        case 3:
          result = `${translate('chat.wednesday')}`;
          break;
        case 4:
          result = `${translate('chat.thursday')}`;
          break;
        case 5:
          result = `${translate('chat.friday')}`;
          break;
        case 6:
          result = `${translate('chat.saturday')}`;
          break;
        default:
          result = '';
      }
    } else {
      switch (date.getDay()) {
        case 0:
          result = `${translate('chat.sunday')}, ${translate('chat.the')}`;
          break;
        case 1:
          result = `${translate('chat.monday')}, ${translate('chat.the')}`;
          break;
        case 2:
          result = `${translate('chat.tuesday')}, ${translate('chat.the')}`;
          break;
        case 3:
          result = `${translate('chat.wednesday')}, ${translate('chat.the')}`;
          break;
        case 4:
          result = `${translate('chat.thursday')}, ${translate('chat.the')}`;
          break;
        case 5:
          result = `${translate('chat.friday')}, ${translate('chat.the')}`;
          break;
        case 6:
          result = `${translate('chat.saturday')}, ${translate('chat.the')}`;
          break;
        default:
          result = '';
      }
      result += ' ' + date.toLocaleDateString();
    }

    let hour = date.getHours().toString();
    if (hour.length === 1) {
      hour = `0${hour}`;
    }

    let min = date.getMinutes().toString();
    if (min.length === 1) {
      min = `0${min}`;
    }

    result += ` – ${hour}:${min}`;

    return result;
  }

  replaceURLs(string, notificationId) {
    const stringWithReplaceURL = string.replace(
      URL_REGEX,
      (url) => `<a href="${url}" target="_blank" data-notification-id="${notificationId}">${url}</a>`
    );

    if (stringWithReplaceURL) {
      return stringWithReplaceURL;
    }

    return string;
  }

  handleAction = (body) => {
    const http = new XMLHttpRequest();
    const url = `${this.apiEndpoint}/web/bot-webhook/${this.config.channelId}`;
    http.open('POST', url, true);

    http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    http.send(JSON.stringify(body));
  }

  sendMessage = async (command) => {
    if (this.preview) {
      if (this.guestsEnabled && this.emailInput && this.nameInput) {
        this.subscriptionId = await this.createGuestSubscription(this.nameInput.value, this.emailInput.value);
        this.preview = false;
      } else {
        return;
      }
    }

    let guestSubscriptionId = '';
    let subscriptionId = '';
    try {
      guestSubscriptionId = localStorage.getItem('cleverpush-guest-subscription-id');
      subscriptionId = localStorage.getItem('cleverpush-subscription-id');
    } catch (ignored) { }
    const isGuest = this.guestsEnabled && !subscriptionId;

    if (this.input?.value || command) {
      const body = {
        text: this.input?.value || command,
        subscriptionId: this.subscriptionId,
        isGuest
      };

      this.handleAction(body);
    }
    if ((this.input.value && this.input.value.length) || command) {
      this.server.call(
        'chat.messages.insert',
        this.config.channelId,
        guestSubscriptionId || '',
        subscriptionId || this.subscriptionId,
        this.input.value || command,
        isGuest
      );
      this.input.value = '';
    }
  }

  renderMedia = (value, type) => {
    const className = `message-${type}`;

    if (!value.mediaUrl) {
      return value.text;
    }

    switch (type) {
      case MEDIA_TYPE.IMAGE:
        return `<div class="chat-element-container">
          <a href="${value.mediaUrl}" target="_blank">
            <img class="${className}" alt="${value.mediaUrl || ''}" src=${value.mediaUrl || ''} />
          </a>
          ${value.text ? `<div class="image-caption white-space-preline">${value.text}</div>` : ''}
        </div>`;
      case MEDIA_TYPE.AUDIO:
        return `<div class="chat-element-container">
          <a href="${value.mediaUrl}" target="_blank">
            <audio controls class="${className}">
              <source src="${value.mediaUrl}" type="audio/ogg">
            </audio>
          </a>
          ${value.text ? `<div class="audio-caption white-space-preline">${value.text}</div>` : ''}
        </div>`;
      case MEDIA_TYPE.VIDEO:
        return `<div class="chat-element-container">
          <a href="${value.mediaUrl}" target="_blank">
            <video width="400" controls class="${className}">
              <source src="${value.mediaUrl}" type="video/mp4">
            </video>
          </a>
          ${value.text ? `<div class="vedio-caption white-space-preline">${value.text}</div>` : ''}
        </div>`;
      default:
        return value.text;
    }
  };

  convertFormatting(text) {
    text = text.replace(/\*\*([\w\d\sÀ-ȕ]+)\*\*/g, '<b>$1</b>');
    text = text.replace(/_([\w\d\sÀ-ȕ]+)_/g, '<i>$1</i>');
    return text;
  }

  renderMessageFromServer = (value) => {
    if (value.type && value.mediaUrl) {
      return this.renderMedia(value, value.type);
    }
    return this.replaceURLs(value.text || '', value.notification || '').trim();
  }

  renderButtons = (value) => {
    if (value.type !== MEDIA_TYPE.BUTTON || !value.actions?.length) {
      return '';
    }

    let buttons = '<hr/>';

    (value.actions || []).forEach((action) => {
      buttons += `
      <div style="display: flex; justify-content: center; margin-top: 10px">
      <a class="cleverpush-action-buttons" style="background-color: ${this.config.chatWidgetThemeColor || '#54B1C4'}" target="_blank" href=${action.url || ''}>${action.title || translate('chat.button')}</a>
      </div>`;
    });

    return buttons;
  }

  handleUrlClick(url, notificationId) {
    if (url?.includes(URL_SHORTENER_DOMAIN) || !notificationId) {
      return;
    }

    const api = new CleverPushApi(this.config.channelId);
    api.notificationUrlClicked(notificationId, url)
      .catch((error) => {
        console.error('Error handling URL click:', error);
      });
  }

  handleUrlClickTracking() {
    const chatMessageUrls = this.chat.querySelectorAll('.cleverpush-chat-message a');
    [...chatMessageUrls].forEach((urlAnker) => {
      if (urlAnker.dataset.clickedListenerAdded) {
        return;
      }
      urlAnker.dataset.clickedListenerAdded = true;

      urlAnker.addEventListener('click', (event) => {
        const url = event.target.href;
        const notificationId = event.target.dataset.notificationId;

        this.handleUrlClick(url, notificationId);
      });
    });
  }

  renderMessages(messages, status, server) {
    this.server = server;

    let bubbles = '';
    let date;
    messages.forEach((value, index) => {
      const nextValue = messages[messages.indexOf(value) + 1];
      const isLastMessage = messages.length - 1 === index;

      if (
        !date
        || (value.createdAt
          && value.createdAt.getTime() - date.getTime() >= 3600000)
      ) {
        date = value.createdAt;
        bubbles += `<span class="cleverpush-chat-date">${this.newDateString(
          value.createdAt
        )}</span>`;
      }

      if (value.subscription && !value.fromChannel) {
        if (nextValue && value.subscription && !nextValue.fromChannel) {
          bubbles += `<div class="cleverpush-chat-subscriber-icon-container"><div class="cleverpush-chat-bubble-subscriber cleverpush-chat-link"><span>${this.convertFormatting(this.renderMessageFromServer(value))}</span></div></div>`;
        } else {
          bubbles += `<div class="cleverpush-chat-subscriber-icon-container"><div class="cleverpush-chat-bubble-subscriber cleverpush-chat-bubble-subscriber-arrow cleverpush-chat-link"><span>${this.convertFormatting(this.renderMessageFromServer(value))}</span></div></div>`;
          bubbles += '<div class="cleverpush-chat-bubble-margin"></div>';
        }
      } else if (nextValue && value.subscription && nextValue.fromChannel) {
        let classList = '';
        if (value.type === MEDIA_TYPE.IMAGE || value.type === MEDIA_TYPE.VIDEO) {
          classList += 'reduce-backgrund-radius';
        }
        bubbles += `<div class="cleverpush-chat-channel-icon-container"><div class="cleverpush-chat-avatar-dummy"></div><div class="cleverpush-chat-bubble-channel cleverpush-chat-link ${classList}"><span>${this.convertFormatting(this.renderMessageFromServer(value))}</span></div></div>`;
      } else {
        let classList = 'cleverpush-chat-bubble-channel-arrow cleverpush-chat-link ';
        if (value.type === MEDIA_TYPE.IMAGE || value.type === MEDIA_TYPE.VIDEO) {
          classList += 'reduce-border-radius';
        }

        if (value.type === MEDIA_TYPE.BUTTON && value.actions?.length) {
          classList += 'no-white-space';
        }

        bubbles += `<div class="cleverpush-chat-channel-icon-container"><img class="cleverpush-chat-avatar-channel" src=${this.config.chatIconUrl || this.config.channelIcon
          } />
        <div class="${classList}">
        <span class="cleverpush-chat-message">${this.convertFormatting(this.renderMessageFromServer(value))}</span>
        ${this.renderButtons(value)}
        </div>
        </div>`;
        bubbles += `<div class="messenger-quick-replies">
        ${isLastMessage ? (value.quickReplies || []).map((action) => `<div class="messenger-quick-reply"> 
                       <button
                        class="messenger-quick-reply-button cleverpush-chat-btn"
                        type="button">
                        ${action.title || ''}
                      </button>
                  </div>`).join('') : ''}
             </div>`;
        bubbles += '<div class="cleverpush-chat-bubble-margin"></div>';
      }
    });

    let mainContainer = `<div class="cleverpush-chat-wrap"><div class="cleverpush-chat-bubble-container">${bubbles}</div></div>`;

    let inputContainer = '<div class="cleverpush-chat-input-container">'
      + `<textarea placeholder="${translate('chat.enterMessage')}" class="cleverpush-chat-input-textarea"></textarea>`
      + '<button type="button" class="cleverpush-chat-emojibtn cleverpush-chat-btn"></button>'
      + '<button type="button" class="cleverpush-chat-sendbtn cleverpush-chat-btn"></button></div>';
    if (this.preview && !this.guestsEnabled) {
      inputContainer = '<div class="cleverpush-chat-input-container">'
        + `<button type="button" class="cleverpush-chat-subscribebtn cleverpush-chat-btn">${translate('chat.enable')}</button></div>`;
    } else if (this.subscriptionId === 'preview' && this.guestsEnabled) {
      inputContainer = '<div class="cleverpush-chat-input-container">'
        + `<button type="button" class="cleverpush-guest-info-submit-button cleverpush-chat-btn">${translate('chat.start')}</button></div>`;

      mainContainer = `
      <div class="cleverpush-chat-wrap">
        <div class="cleverpush-chat-guest-info-container">
          <div class="cleverpush-label"><strong>${translate('chat.name')}</strong> (optional)</div>
          <input type="text" class="cleverpush-input cleverpush-guest-name-input" />
          <hr class="cleverpush-br">
          <div class="cleverpush-label"><strong>${translate('chat.emailAddress')}</strong></div>
          <input type="email" class="cleverpush-input cleverpush-guest-email-input" />
          <div class="cleverpush-email-error-case">
            <svg width="16" height="16" viewBox="0 0 16 16" focusable="false" role="presentation"><g fill="none" stroke="currentColor"><circle cx="7.5" cy="8.5" r="7"></circle><path stroke-linecap="round" d="M7.5 4.5V9"></path></g><circle cx="7.5" cy="12" r="1" fill="currentColor"></circle></svg>${translate('chat.emailError')}
          </div>
        </div>
      </div>
      `;
    }

    let Header = '';

    if (status === 'disconnected') {
      Header = '<div class="cleverpush-chat-status">Verbindung unterbrochen</div>';
    } else if (status === 'connecting') {
      Header = '<div class="cleverpush-chat-status">Wird geladen...</div>';
    }

    if (this.chat && this.subscriptionId === 'preview' && this.guestsEnabled) {
      // Ask Guest to enter Name(Optional) and Email
      this.chat.innerHTML = Header + mainContainer + inputContainer;
    } else if (this.chat && this.subscriptionId) {
      this.chat.innerHTML = Header + mainContainer + inputContainer;
    }

    this.handleUrlClickTracking();

    this.input = this.chat.querySelector('.cleverpush-chat-input-textarea');
    this.sendBtn = this.chat.querySelector('.cleverpush-chat-sendbtn');
    this.emojiBtn = this.chat.querySelector('.cleverpush-chat-emojibtn');
    this.subscribeBtn = this.chat.querySelector(
      '.cleverpush-chat-subscribebtn'
    );
    this.nameInput = this.chat.querySelector('.cleverpush-guest-name-input');
    this.emailInput = this.chat.querySelector('.cleverpush-guest-email-input');
    this.emailErrorLabel = this.chat.querySelector('.cleverpush-email-error-case');
    this.submitGuestInfoButton = this.chat.querySelector('.cleverpush-guest-info-submit-button');
    this.quickReplyButtons = this.chat.querySelectorAll('.messenger-quick-reply-button');

    (this.quickReplyButtons || []).forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.sendMessage(event.target.innerText);
      });
    });

    if (this.emojiBtn) {
      const picker = new EmojiButton({ position: 'top-end' });
      this.emojiBtn.addEventListener('click', () => {
        picker.pickerVisible
          ? picker.hidePicker()
          : picker.showPicker(this.emojiBtn);
      });
      picker.on('emoji', (emoji) => {
        this.input.value += emoji;
      });
    }

    if (this.sendBtn) {
      this.sendBtn.addEventListener('click', () => this.sendMessage());
    }

    if (this.submitGuestInfoButton) {
      this.submitGuestInfoButton.addEventListener('click', () => {
        if (this.guestsEnabled && this.emailInput.value === '') {
          this.emailInput.classList.add('error');
          this.emailErrorLabel.classList.add('active');
        } else if (this.guestsEnabled && this.emailInput && this.nameInput) {
          const inputContainer = '<div class="cleverpush-chat-input-container">'
            + `<textarea placeholder="${translate('chat.enterMessage')}" class="cleverpush-chat-input-textarea"></textarea>`
            + '<button type="button" class="cleverpush-chat-emojibtn cleverpush-chat-btn"></button>'
            + '<button type="button" class="cleverpush-chat-sendbtn cleverpush-chat-btn"></button></div>';

          mainContainer = `<div class="cleverpush-chat-wrap"><div class="cleverpush-chat-bubble-container">${bubbles}</div></div>`;

          this.chat.innerHTML = Header + mainContainer + inputContainer;
          this.emojiBtn = this.chat.querySelector('.cleverpush-chat-emojibtn');
          this.input = this.chat.querySelector('.cleverpush-chat-input-textarea');
          this.sendBtn = this.chat.querySelector('.cleverpush-chat-sendbtn');
          if (this.sendBtn) {
            this.sendBtn.addEventListener('click', () => this.sendMessage());
          }
        }
      });
    }

    if (this.subscribeBtn) {
      this.subscribeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.CleverPush) {
          window.CleverPush.isSubscribed((subscribed) => {
            if (this.config.chatGuestsEnabled) {
              this.createGuestSubscription();
              window.CleverPush.getTopics((err, topics) => {
                if (
                  topics
                  && !isNaN(topics.length)
                  && topics.indexOf(window.CleverPush.config.chatTopicId) < 0
                ) {
                  window.CleverPush.setTopics(
                    [...topics, window.CleverPush.config.chatTopicId],
                    () => {
                      location.reload();
                    }
                  );
                } else {
                  this.subscribeBtn.disabled = false;
                }
              });
            } else if (subscribed && window.CleverPush.config.chatTopicId) {
              window.CleverPush.getTopics((err, topics) => {
                if (
                  topics
                  && !isNaN(topics.length)
                  && topics.indexOf(window.CleverPush.config.chatTopicId) < 0
                ) {
                  window.CleverPush.setTopics(
                    [...topics, window.CleverPush.config.chatTopicId],
                    () => {
                      location.reload();
                    }
                  );
                } else {
                  this.subscribeBtn.disabled = false;
                }
              });
            } else {
              // Ask for subscribe
              this.subscribe((err, subscriptionId) => {
                if (!err && subscriptionId) {
                  location.reload();
                } else {
                  this.subscribeBtn.disabled = false;
                }
              });
            }
          });
        } else {
          window.cleverpushHandleSubscribe();
        }
      });
    }

    if (this.input) {
      this.input.addEventListener('change', () => {
        this.chat.scrollTop = this.chat.scrollHeight;
      });
      autosize(this.input);
    }

    const bubbleContainers = document.getElementsByClassName(
      'cleverpush-chat-bubble-container'
    );
    for (const container of bubbleContainers) {
      container.scrollTop = container.scrollHeight;
    }
  }

  subscribe(cb) {
    if (!window.CleverPush) {
      return;
    }

    if (!window.CleverPush.subscriptionManager) {
      alert('Der genutzte Browser unterstützt leider keine Push Nachrichten.');
      return;
    }

    const notificationPermission = window.CleverPush.subscriptionManager.getNotificationPermission(
      true
    );
    const showBackdrop = notificationPermission === 'default';

    const callback = (err) => {
      if (window.CleverPush.confirm && showBackdrop) {
        window.CleverPush.confirm.hideBackdrop();
      }

      if (
        err
        && this.config.ownDomain
        && location.protocol === 'https:'
        && (err.reason === 'denied' || err.reason === 'default')
      ) {
        if (window.CleverPush.subscriptionManager.confirm) {
          window.CleverPush.subscriptionManager.confirm.showBackdrop(
            undefined,
            'denied',
            err.message
          );
        }
        cb(err, false);
      } else if (err) {
        cb(err, false);
        log.error(err);
      } else {
        cb(err, localStorage.getItem('cleverpush-subscription-id'));
      }
    };

    if (
      window.CleverPush.confirm
      && (this.config.showConfirmAlert
        || !this.config.ownDomain
        || !(
          window.top.location.protocol === 'https:'
          || window.top.location.hostname === 'localhost'
        ))
    ) {
      window.CleverPush.confirm.setAutoHideBackdrop(
        notificationPermission === 'granted' || isAndroid()
      );
      window.CleverPush.confirm.show(callback);
    } else if (!window.CleverPush.subscriptionManager.isSubscribing) {
      const subscribe = () => {
        window.CleverPush.subscriptionManager
          .subscribeForce(window.CleverPush.subscriptionManager.status)
          .then((permission) => {
            if (window.CleverPush.confirm && showBackdrop) {
              window.CleverPush.confirm.hideBackdrop();
            }

            if (permission === 'denied') {
              if (window.CleverPush.subscriptionManager.confirm) {
                window.CleverPush.subscriptionManager.confirm.showBackdrop(
                  undefined,
                  'denied',
                  translate('popup.info').formatCleverPush(
                    `<strong>${translate('confirm.allowBrowser')
                    || translate('confirm.allow')
                    }</strong>`
                  )
                );
              }
            } else {
              callback(null);
            }
          })
          .catch((err) => {
            if (
              notificationPermission !== 'default'
              && err.reason === 'denied'
            ) {
              if (window.CleverPush.subscriptionManager.confirm) {
                window.CleverPush.subscriptionManager.confirm.showBackdrop(
                  undefined,
                  'denied',
                  err.message
                );
              }
            }

            callback(showBackdrop, err);
          });
      };

      domLoaded().then(() => {
        if (window.CleverPush.confirm && showBackdrop) {
          window.CleverPush.confirm.showBackdrop();
          subscribe();
        } else if (
          window.CleverPush.confirm
          && notificationPermission === 'granted'
        ) {
          window.CleverPush.confirm.appendConfirmBox(
            this.config.confirmAlertTheme,
            undefined,
            undefined,
            (allowed) => {
              if (allowed) {
                subscribe();
              }
            }
          );
        } else {
          subscribe();
        }
      });
    }
  }
}

export function initChatWidget(config) {
  if (!window.cleverpushChatLoaded && config.displayChatWidget && config.chatWidgetPath && new RegExp(config.chatWidgetPath).test(location.pathname)) {
    const script = document.createElement('script');
    script.src = 'https://static.cleverpush.com/sdk/cleverpush-chat.js';
    document.head.appendChild(script);
  }
}
